module.exports = __webpack_public_path__ + "img/image-remove-icon.d1078b4c.svg";